import type SmimeAdminSettingsType from 'owa-service/lib/contract/SmimeAdminSettingsType';
import { getStore } from '../store/store';

export default function getSmimeAdminSettings(): SmimeAdminSettingsType | undefined {
    return getStore().userConfiguration?.SmimeAdminSettings;
}
